import { render, staticRenderFns } from "./FormConfig.vue?vue&type=template&id=50e38202&"
import script from "./FormConfig.vue?vue&type=script&lang=js&"
export * from "./FormConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports